<ng-container *ngIf="isLoaded; else loaderBlock">
  <div
    class="landing"
    *transloco="let t">
    <div
      class="landing_hero __full-screen"
      appBackgroundBranded>
      <div class="landing_hero_main">
        <!-- If user follows invitation link with it disabled in admin panel -->
        <div class="fb-panel">
          <div style="flex-grow: 1">
            <div class="text-center">
              <img
                src="/assets/images/project/intro/email.svg"
                [alt]="t('company-settings.services.email.title')"
                style="max-width: 292px" />
            </div>

            <h2
              class="fb-panel_title"
              style="margin-top: 14px">
              {{ t('registration.user.invitation-sent.check-your-email') }}
            </h2>

            <div
              class="fb-panel_row"
              [innerHTML]="t('registration.user.invitation-sent.open-and-confirm', { email: email })"></div>
          </div>
          <span [innerHTML]="t('registration.user.invitation-sent.if-not-arrive', { supportLink: supportLink })"></span>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #loaderBlock>
  <app-icon
    class="layout_spinner"
    name="spinner"></app-icon>
</ng-template>
